import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var go = normalize.go(function (options) {
  var step = options.step,
    success = options.success,
    fail = options.fail,
    complete = options.complete;
  if (step < 0) {
    setTimeout(function () {
      history.go(options.step);
      success && success();
      complete && complete();
    });
  } else {
    fail && fail({
      errMsg: 'step不能大于或等于0'
    });
    complete && complete({
      errMsg: 'step不能大于或等于0'
    });
  }
}, CONTAINER_NAME.WEB);
export default go;